import React, { useState, ChangeEvent } from 'react';

interface InputFieldProps {
  label: string;
  type: string;
  addPrefix?: boolean;
  validateEmail?: boolean;
  placeholder?: string;
  id?: string;
  error?: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  required?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({ 
  label, 
  type, 
  addPrefix = false, 
  validateEmail = false, 
  placeholder = '', 
  id, 
  error,
  value: controlledValue,
  onChange,
  onBlur,
  required = false
}) => {
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');
  const [internalValue, setInternalValue] = useState(addPrefix ? "+" : "");
  
  // Use controlled value if provided, otherwise use internal state
  const value = controlledValue !== undefined ? controlledValue : internalValue;
  const isControlled = controlledValue !== undefined;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value;

    if (addPrefix) {
      val = val.startsWith("+") ? val : "+" + val.replace(/[^0-9]/g, "");
    }

    if (isControlled && onChange) {
      onChange(val);
    } else {
      setInternalValue(val);
    }
  };

  const handleBlur = () => {
    if (onBlur) {
      onBlur();
    }
  };

  return (
    <div className="mb-9">
      <label htmlFor={inputId} className="mb-2.5 text-sm font-bold text-black block">
        {label}
        {required && <span className="text-red-600 ml-1">*</span>}
      </label>
      <input
        type={type}
        id={inputId}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={handleBlur}
        required={required}
        className={`px-0 py-2.5 w-full border-b border-solid ${
          error ? 'border-red-600' : 'border-b-black'
        }`}
      />
      {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default InputField;